import React from 'react';
import { getMyClientRequest } from '@services/external/client.api';
import { FormattedMessage } from 'react-intl';
import { call, put, select, takeLatest } from 'typed-redux-saga/macro';
import { showNotification } from '../../helpers/notification-helper';
import { memberApiV2 } from '../../lib/api';
import TStore from '../../types/store';
import { patientActionTypes } from '../ducks/patients';

function* getWaitingRequest() {
  try {
    const providerId: string = yield select((state: TStore) => state.users.business[0].id);

    const response = yield* call(getMyClientRequest, providerId);

    yield put({
      type: patientActionTypes.GET_WAITING_SUCCESS,
      payload: response.data.data,
    });
  } catch {}
}

function* getPatientDetailRequest({ payload }: any) {
  try {
    const patientReq: any = yield* call(memberApiV2.getProfileById, payload.providerId, payload.id);

    yield put({
      type: patientActionTypes.GET_PATIENT_DETAIL_SUCCESS,
      payload: {
        ...patientReq.data.data,
        profileImage: patientReq.data.data.profile.profileImage,
      },
    });
  } catch {
    showNotification({
      type: 'ERROR',
      title: <FormattedMessage id="server_error.default" />,
      copy: <FormattedMessage id="server_error.profile_detail" />,
    });
  }
}

function* patientsSaga() {
  yield takeLatest(patientActionTypes.GET_WAITING_REQUEST, getWaitingRequest);
  yield takeLatest(patientActionTypes.GET_PATIENT_DETAIL_REQUEST, getPatientDetailRequest);
}

export default patientsSaga;
